import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">
              亚洲人成长之路
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为亚洲人提供系统性的成长指引，涵盖职业发展、个人成长、文化认同与自我提升等方面。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/career-development" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  职业发展规划
                </Link>
              </li>
              <li>
                <Link to="/category/personal-growth" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  个人成长方法论
                </Link>
              </li>
              <li>
                <Link to="/category/cultural-identity" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  文化认同与归属
                </Link>
              </li>
              <li>
                <Link to="/category/leadership" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  领导力与影响力
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              更多内容
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/cross-cultural" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  跨文化沟通
                </Link>
              </li>
              <li>
                <Link to="/category/lifelong-learning" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  教育与终身学习
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关于
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#newsletter" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">
                  订阅资讯
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 亚洲人成长之路. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-background-100 transition-colors" aria-label="知乎">
              <i className="ri-question-answer-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}